import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { CatalogPaginationRequest } from "../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { UserLogsAPIService } from "../../shared/services/API/User-LogsAPI.service";

@Injectable({
  providedIn: "root",
})
export class UserLogsService {
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private userLogs: UserLogsAPIService) {
    this.estatus = new EstatusJSON();
  }

  // getUsersPaged(): Observable<any[]> {
  //   return this.http.get<UsersPaged[]>(this.configUrl + "/api/AuthManagement/GetUsers", {});
  // }


  getActivePage(page, dato): any {
    return this.userLogs.getActivePage(page, dato);
  }
  getFilterCount(dato): any {
    return this.userLogs.getFilterCount(dato);
  }
  getActiveCount(dato): any {
    return this.userLogs.getActiveCount(dato);
  }
  getFilterPage(page, dato): any {
    return this.userLogs.getFilterPage(page, dato);
  }

  getFilter(filtro): any {
    return this.userLogs.getFilter(filtro);
  }


  //los únicos necesarios
  getCount(pageRequest: CatalogPaginationRequest) {
    return this.userLogs.getCount(pageRequest);
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    return this.userLogs.getPage(pageRequest);
  }

  //tal vez
  delete(UserId): any{
    console.log("no hay delete");
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }
  
}
